<template>
  <div v-if="allLoad">
    <div class="flex">
      <svg width="151" height="32" viewBox="0 0 151 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_36360_226064)">
          <path d="M63.3511 24.3108C60.2369 24.3108 58.3775 23.5472 58.3775 22.8177C58.3775 21.8788 60.4251 21.2171 63.3511 21.2171C66.2771 21.2171 68.416 21.8732 68.416 22.8177C68.416 23.5529 66.5224 24.3108 63.3511 24.3108ZM63.3511 18.2422C57.5162 18.2422 54.0312 19.9332 54.0312 22.7668C54.0312 25.6003 57.6246 27.2913 63.4081 27.2913C69.1917 27.2913 72.7565 25.5154 72.7565 22.7668C72.7565 20.0181 69.1518 18.2422 63.3454 18.2422" fill="#002452"/>
          <path d="M96.4269 4.87145V4.71875H78.3519V7.67103H92.2005C92.2062 8.97184 91.9723 11.63 91.6415 12.8799H76.5039V15.8322H85.1108V18.53H77.8728V21.5105H92.1092V27.285H96.3357V18.53H89.3657V15.8322H97.9726V12.8799H95.7311C96.233 10.94 96.4897 7.77849 96.4269 4.87145Z" fill="#002452"/>
          <path d="M138.56 24.3084C135.52 24.3084 133.706 23.6071 133.706 22.4307C133.706 21.2543 135.566 20.5813 138.56 20.5813C141.555 20.5813 143.505 21.2883 143.505 22.4307C143.505 23.5732 141.657 24.3084 138.56 24.3084ZM138.56 17.5781C132.902 17.5781 129.389 19.4389 129.389 22.4307C129.389 25.4226 132.817 27.2833 138.56 27.2833C144.304 27.2833 147.852 25.4678 147.852 22.4307C147.852 19.3936 144.292 17.5781 138.56 17.5781Z" fill="#002452"/>
          <path d="M140.261 6.00386V5.83984H127.376V8.89393H135.498C134.888 11.6935 131.18 14.2782 126.623 15.0643L126.406 15.1039L128.083 18.0618L128.197 18.0392C135.937 16.2237 139.998 12.1742 140.261 6.00386Z" fill="#002452"/>
          <path d="M123.388 4.16406H119.869V27.2903H123.388V4.16406Z" fill="#002452"/>
          <path d="M114.992 11.8393H111.992V15.0687H114.992V26.5894H118.506V4.71875H114.992V11.8393Z" fill="#002452"/>
          <path d="M108.925 9.57436V8.76559H113.105V5.83594H101.048V8.76559H105.229V9.57436C105.229 13.4598 104.344 16.5705 100.027 19.0929L99.8613 19.1891L102.171 21.6889L102.206 21.7285L102.314 21.6776C104.036 20.8292 106.147 18.6574 107.077 16.7854C108.006 18.6574 110.117 20.8292 111.839 21.6776L111.942 21.7285L114.286 19.1891L114.121 19.0929C109.803 16.5648 108.919 13.4598 108.919 9.57436" fill="#002452"/>
          <path d="M143.271 4.16406V17.2118H147.498V12.3762H150.487V9.14674H147.498V4.16406H143.271Z" fill="#002452"/>
          <path d="M65.5694 14.196V12.8047H72.5793V9.85238H58.6394V7.72584H72.5736V4.72266H54.413V12.8047H61.3145V14.196H52.6562V17.1482H74.1307V14.196H65.5694Z" fill="#002452"/>
          <path d="M44.6034 4.72266H36.5498L25.5645 16.8146L35.0668 27.2776H43.1204L33.6181 16.8146L44.6034 4.72266Z" fill="#002452"/>
          <path d="M11.7715 32.0015H19.2947L27.8103 22.63L24.0459 18.4844L11.7715 32.0015Z" fill="#C51F2A"/>
          <path d="M30.2704 0L20.2832 10.9947L24.0419 15.1347L37.7936 0H30.2704Z" fill="#C51F2A"/>
          <path d="M19.1873 14.0924C19.1701 13.9793 19.1473 13.8662 19.1245 13.7531C18.9534 12.9273 18.6853 12.1355 18.3431 11.3833C18.2918 11.2702 18.2404 11.1571 18.1834 11.044C16.3297 7.33384 12.4797 4.77181 8.12207 4.72656H5.94326H0V11.044H8.1734C8.81222 11.044 9.42252 11.1684 9.98148 11.3833C11.1279 11.8245 12.069 12.6728 12.6223 13.7531C12.6793 13.8662 12.7364 13.9793 12.782 14.0924C13.0273 14.6806 13.1641 15.3197 13.1641 15.9927C13.1641 18.0967 11.8409 19.8839 9.97577 20.6021C9.41681 20.8171 8.80652 20.9415 8.1677 20.9415H5.59533V14.0868H0.0114074L0 27.2702H8.37874C12.6337 27.1288 16.3696 24.5838 18.1891 20.9415C18.2461 20.8284 18.2975 20.7153 18.3488 20.6021C18.9933 19.1939 19.3527 17.6385 19.3527 15.9984C19.3527 15.348 19.2956 14.7089 19.1873 14.0868" fill="#002452"/>
        </g>
        <defs>
          <clipPath id="clip0_36360_226064">
            <rect width="150.486" height="32" fill="white"/>
          </clipPath>
        </defs>
      </svg>
      <h1 class="flex-1 text-center" style="font-weight: 700; font-size:32px;">일 안전작업허가(일반보수)</h1>
      <div class="flex justify-end">
        <div style="margin-right:20px; font-weight: 500; font-size:15px;">[승인/확인용 QR]</div>
        <div style="width: 106px; height: 106px; padding: 2px; border: 1px solid #333;" class="flex justify-center items-center">
          <img v-if="qrCodeDataUrl" :src="qrCodeDataUrl" width="100" height="100" alt="QR Code" />
          <canvas v-else ref="qrCanvas" width="100" height="100" style="display: none;"></canvas>
        </div>
      </div>
    </div>

    <ul class="options black">
      <li><h5>■ 일 안전작업허가번호: </h5>{{ form.작업정보.허가번호 }}</li>
      <li><h5>■ TBM 진행 여부: </h5>
        <span v-if="tbmStatus === '미진행'" style="color:#EA5455">{{ tbmStatus }}</span>
        <span v-if="tbmStatus === '진행중'" style="color:#FF9F43">{{ tbmStatus }}</span>
        <span v-if="tbmStatus === '완료'" style="color:#28C76F">{{ tbmStatus }}</span>
      </li>
      <li>
        <h5>■ 허가 신청자: </h5>
        <h5>팀(업체): </h5><span style="min-width: 40px; margin:0 4px;">{{form.stdInfo.section}}</span>
        <h5>직책: </h5><span style="min-width: 40px; margin:0 4px;">{{form.stdInfo.rank}}</span>
        <h5>성명: </h5><span style="min-width: 40px; margin:0 4px;">{{form.stdInfo.writer_name}}</span>
      </li>
      <li><h5>■ 허가승인: </h5>{{new Date(form.작업허가.작업승인.승인일시).format('yyyy년 MM월 dd일 HH:mm')}}</li>
      <li><h5>■ 허가신청기간: </h5>{{new Date(form.작업허가.작업시작일시).format('yyyy년 MM월 dd일')}}
        {{ form.작업허가.작업시간.시작 }}~{{ form.작업허가.작업시간.종료 }}</li>
      <li>
        <h5>■ 허가승인자: </h5>
        <h5>팀(업체): </h5><span style="min-width: 40px; margin:0 4px;">{{ form.작업허가.작업승인.승인자.부서 }}</span>
        <h5>직책: </h5><span style="min-width: 40px; margin:0 4px;">{{ form.작업허가.작업승인.승인자.직책 }}</span>
        <h5>성명: </h5><span style="min-width: 40px; margin:0 4px;">{{ form.작업허가.작업승인.승인자.성명 }}</span>
        <div style="color:#9CA0A4; font-size:14px; font-weight: 500;">
          (서명)
          <img v-if="form.작업허가.작업승인.승인자.서명" :src="form.작업허가.작업승인.승인자.서명.path" style="position: absolute; inset:50%; width:100px; transform: translate(-50%, -50%);">
        </div>
      </li>
      <li v-if="form.작업허가.작업시간.연장"><h5>■ 연장신청기간: </h5>{{new Date(form.작업허가.연장종료일시).format('yyyy년 MM월 dd일')}}
        {{ form.작업허가.작업시간.시작 }}~{{ form.작업허가.작업시간.연장 }}</li>
      <li v-if="form.작업허가.작업시간.연장">
        <h5>■ 연장승인자: </h5>
        <h5>팀(업체): </h5><span style="min-width: 40px; margin:0 4px;">{{ form.작업허가.연장승인.승인자.부서 }}</span>
        <h5>직책: </h5><span style="min-width: 40px; margin:0 4px;">{{ form.작업허가.연장승인.승인자.직책 }}</span>
        <h5>성명: </h5><span style="min-width: 40px; margin:0 4px;">{{ form.작업허가.연장승인.승인자.성명 }}</span>
        <div style="color:#9CA0A4; font-size:14px; font-weight: 500;">(서명)</div>
      </li>
      <li><h5>■ 작업완료시간: </h5>{{ new Date(form.작업허가.작업종료.승인일시).format('yyyy년 MM월 dd일 HH:mm') }}</li>
      <li>
        <h5>■ 확인자(안전환경팀, 필요시): </h5>
        <h5>팀(업체): </h5><span style="min-width: 40px; margin:0 4px;">{{form.안전관계자.확인자 && form.안전관계자.확인자.section ? form.안전관계자.확인자.section : ''}}</span>
        <h5>직책: </h5><span style="min-width: 40px; margin:0 4px;">{{form.안전관계자.확인자 && form.안전관계자.확인자.rank ? form.안전관계자.확인자.rank : ''}}</span>
        <h5>성명: </h5><span style="min-width: 40px; margin:0 4px;">{{form.안전관계자.확인자 && form.안전관계자.확인자.name ? form.안전관계자.확인자.name : ''}}</span>
        <div style="color:#9CA0A4; font-size:14px; font-weight: 500; position: relative">
          (서명)
          <img v-if="form.안전관계자.확인자서명 && form.안전관계자.확인자서명.sign" :src="form.안전관계자.확인자서명.sign" style="position: absolute; inset:50%; width:100px; transform: translate(-50%, -50%);">
        </div>
      </li>
    </ul>

    <ul class="options blue">
      <li><h5>■ 작업 내용: </h5>{{form.작업정보.작업내용}}</li>
      <li><h5>■ 작업 장소: </h5>{{form.작업정보.작업구역.region.name}} {{form.작업정보.작업구역.zone.name}}</li>
      <li><h5>■ 업체 안전전담자: </h5>{{ getSafetyManager }}</li>
      <li><h5>■ 작업 인원수: </h5>{{form.작업자내역.length}}명</li>
      <li class="col-span-2 gap-2">
        <h5>■ 작업유형: </h5>
        <span v-for="item in form.inspectList" :key="`작업유형_${item.id}`"
              class="flex items-center gap-2">
          <print-checkbox :value="item.checked"/>{{ item.label }}
        </span>
      </li>
    </ul>

    <p style="margin-top: 17px; font-weight: 400; font-size: 14px">※ 최초허가기간(최대 8시간) 종료후 최대 4시간까지 연장허가 가능</p>
    <div class="grid grid-cols-2 gap-1">
      <table v-for="(inspect, i_i) in inspectList" :key="`inspect_${inspect.id}`" class="col-span-1 ">
        <colgroup>
          <col />
          <col width="60"/>
          <col width="60"/>
          <col width="60"/>
        </colgroup>
        <tr>
          <th class="text-left">◇ {{ inspect.label }}</th>
          <th class="px-0">신청자</th>
          <th class="px-0">허가자</th>
          <th class="px-0">연장허가</th>
        </tr>
        <tr v-for="i in rowCount(inspectList, i_i) ">
          <template v-if="inspectList[i_i].list[i-1]">
            <td>
              <span v-html="inspectList[i_i].list[i-1].content"></span>
              <span v-if="inspectList[i_i].list[i-1].rowType === 'customContent'">
                <!-- 일반작업 -->
                <span v-if="i_i === 0" class="ml-1" style="color: #4839EB;">(
                  <span class="mr-1">위치 :</span>
                  <span>{{ inspectList[i_i].list[i-1].위치 }}</span>
                  )
                </span>

                <!-- 화기작업 -->
                <span v-if="i_i === 1" class="ml-1" style="color: #4839EB;">(
                  <span class="mr-1">성명 :</span>
                  <span>{{ inspectList[i_i].list[i-1].성명 }}</span>
                  )
                </span>

                <!-- 중장비 관련 작업 -->
                <span v-else-if="i_i === 3" class="ml-1" style="color: #4839EB;">(
                  <span>{{ inspectList[i_i].list[i-1].투입장비 }}</span>
                  )
                </span>

                <!-- 정전(전기차단)작업 -->
                <span v-if="i_i === 5" class="ml-1" style="color: #4839EB;">
                  <span v-if="inspectList[i_i].list[i-1].customType === '1'">(
                    <span>차단기 번호:</span>
                    <span>{{ inspectList[i_i].list[i-1].차단기번호 }}</span>
                    )
                  </span>
                  <span v-else-if="inspectList[i_i].list[i-1].customType === '2'">{
                    <span style="color: #4839EB;">차단자:</span>
                    <span>{{ inspectList[i_i].list[i-1].차단자 }}</span>
                    /
                    <span style="color: #4839EB;">차단시간:</span>
                    <span>{{ inspectList[i_i].list[i-1].차단시간 }}</span>
                    }
                  </span>
                  <span v-else-if="inspectList[i_i].list[i-1].customType === '3'">(
                    <span style="color: #4839EB;">복구자:</span>
                    <span>{{ inspectList[i_i].list[i-1].복구자 }}</span>
                    /
                    <span style="color: #4839EB;">복구시간:</span>
                    <span>{{ inspectList[i_i].list[i-1].복구시간 }}</span>
                    )
                  </span>
                </span>

                <!-- 방사선 관련 작업 -->
                <span v-if="i_i === 7" class="pl-1" style="color:#4839EB;" >(
                  {{ inspectList[i_i].list[i-1].작업감시자 }}
                  )</span>
              </span>
            </td>
            <td class="text-center"><div class="flex justify-center">
              <PrintCheckbox :value="inspectList[i_i].list[i-1].isChecked.includes('신청자')"/>
            </div></td>
            <td class="text-center"><div class="flex justify-center">
              <PrintCheckbox :value="inspectList[i_i].list[i-1].isChecked.includes('허가자')"/>
            </div></td>
            <td class="text-center"><div class="flex justify-center">
              <PrintCheckbox :value="inspectList[i_i].list[i-1].isChecked.includes('연장허가')"/>
            </div></td>
          </template>
          <template v-else>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
          </template>
        </tr>
      </table>
    </div>
    <div class="mt-1 grid grid-cols-2 gap-1">
      <table v-if="has(inspectList, '화기작업')">
        <colgroup>
          <col width="60"/>
          <col width=""/>
          <col width="70"/>
          <col width="70"/>
          <col width="70"/>
          <col width=""/>
        </colgroup>
        <tr>
          <th rowspan="9" class="px-0">가스농도<br>측정결과<br>(화기작업)</th>
          <th>물질명</th>
          <th>결과</th>
          <th>측정시간</th>
          <th>측정자</th>
          <th>비고</th>
        </tr>
        <tr v-for="(item, i) in subList.화기작업" :key="`화기작업_subList_${i}`" >
          <td class="text-center">{{item ? item.물질명 : '&nbsp;'}}</td>
          <td class="text-center" style="font-size:13px;">{{item ? item.결과 : '&nbsp;'}}</td>
          <td class="text-center">{{item ? item.측정시간 : '&nbsp;'}}</td>
          <td class="text-center">{{item ? item.측정자 : '&nbsp;'}}</td>
          <td class="text-center">{{item ? item.비고 : '&nbsp;'}}</td>
        </tr>
      </table>
      <table v-if="has(inspectList, '밀폐공간 작업')">
        <colgroup>
          <col width="60"/>
          <col width="70"/>
          <col width="80"/>
          <col width="65"/>
          <col width="70"/>
          <col width="70"/>
          <col width=""/>
        </colgroup>
        <tr>
          <th rowspan="9" class="px-0">가스농도<br>측정결과<br>(밀폐공간)</th>
          <th>물질명</th>
          <th>기준</th>
          <th>결과</th>
          <th>측정시간</th>
          <th>측정자</th>
          <th>비고</th>
        </tr>
        <tr v-for="(item, i) in subList.밀폐공간" :key="`밀폐공간_subList_${i}`" >
          <td class="text-center">{{item ? item.물질명 : '&nbsp;'}}</td>
          <td class="text-center px-0" style="font-size:13px;">{{item ? item.기준 : '&nbsp;'}}</td>
          <td class="text-center" style="font-size:13px;">{{item ? item.결과 : '&nbsp;'}}</td>
          <td class="text-center">{{item ? item.측정시간 : '&nbsp;'}}</td>
          <td class="text-center">{{item ? item.측정자 : '&nbsp;'}}</td>
          <td class="text-center">{{item ? item.비고 : '&nbsp;'}}</td>
        </tr>
      </table>
      <p class="col-span-2">※ 적정공기 : 산소(O2) 18% 이상 23.5% 미만, 탄산가스(CO2) 1.5% 미만, 일산화탄소(CO) 30ppm 미만, 황화수소(H2S) 10ppm 미만 / 그 외 가스 등은 관계법령 참조</p>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcode';
import config from "../../../../../public/config";
import PrintCheckbox from "@/components/print/PrintCheckbox.vue";
import PrintRadio from "@/components/print/PrintRadio.vue";

export default {
  name: "Print",
  components: {
    PrintCheckbox,
    PrintRadio,
  },
  props: {
    form: Object,
    projectId: [String, Number],
    boardId: [String, Number],
    postId: [String, Number],
    tbmStatus: String,
  },
  computed: {
    BASE_URL() {
      return config.BASE_URL;
    },
    BASE_API_URL() {
      return config.BASE_API_URL;
    },
    currentUrl() {
      return `${this.BASE_URL}/project/${this.projectId}/tab/${this.boardId}/write/${this.postId}`;
    },
    allLoad () {
      return this.form.작업허가.작업승인 ;
    },
    inspectList () {
      return this.form.inspectList.filter(item => item.checked);
    },
    subList() {
      let 화기작업 = []
      let 밀폐공간 = []

      for (let i=0; i<this.inspectList.length; i++) {
        const find = this.inspectList[i]
        if (find.label === '화기작업') {
          화기작업 = find.subList.map(item => {
            return {
              물질명: item.물질명,
              결과: item.결과 + ' LEL%',
              측정시간: item.측정시간,
              측정자: item.측정자,
              비고: item.비고,
            }
          })
        }
        else if (find.label === '밀폐공간 작업') {
          for (let i=0; i<find.subList.length; i++) {
            const item = find.subList[i]
            밀폐공간.push({
              물질명: 'O2',
              기준: '18%~23.5%',
              결과: item.산소 + '%',
              측정시간: item.측정시간,
              측정자: item.측정자,
              비고: item.비고,
            })
            밀폐공간.push({
              물질명: 'CO2',
              기준: '1.5% ↓',
              결과: item.탄산가스 + '%',
              측정시간: item.측정시간,
              측정자: item.측정자,
              비고: item.비고,
            })
            밀폐공간.push({
              물질명: 'CO',
              기준: '30ppm ↓',
              결과: item.일산화탄소 + 'ppm',
              측정시간: item.측정시간,
              측정자: item.측정자,
              비고: item.비고,
            })
            밀폐공간.push({
              물질명: 'H2S',
              기준: '10ppm ↓',
              결과: item.황화수소 + 'ppm',
              측정시간: item.측정시간,
              측정자: item.측정자,
              비고: item.비고,
            })
          }

        }
      }

      // 화기작업과 밀폐공간의 길이를 비교하여 더 긴 배열의 길이로 array 개수 맞춤
      const maxLength = Math.max(4, Math.max(화기작업.length, 밀폐공간.length));
      화기작업.length = maxLength;
      밀폐공간.length = maxLength;

      return { 화기작업, 밀폐공간 }
    },
    getSafetyManager() {
      return this.form.작업자내역.length > 0 ?
        this.form.작업자내역.filter(item => item.직위 === "안전전담자")  // '안전전담자'만 필터링
        .map(item => item.userName)  // userName만 추출
        .join(", ") : "없음";
    },
  },
  data() {
    return {
      qrCodeDataUrl: null
    };
  },
  mounted() {
    this.generateQRCode();
  },
  methods: {
    async generateQRCode() {
      try {
        // Canvas에 QR 코드 생성
        const canvas = this.$refs.qrCanvas;
        if (canvas) {
          await QRCode.toCanvas(canvas, this.currentUrl, {
            width: 100,
            margin: 1,
            errorCorrectionLevel: 'L', // Low level (가장 단순한 형상)
            type: 'png',
            quality: 0.92,
            color: {
              dark: '#000000',
              light: '#FFFFFF'
            }
          });

          // Canvas를 Data URL로 변환하여 이미지로 사용
          this.qrCodeDataUrl = canvas.toDataURL('image/png');
        }
      } catch (error) {
        console.error('QR Code generation failed:', error);
      }
    },
    /**
     * rowIndex 행의 셀 개수를 반환 (2단으로 표현하기 위해서 좌우 row 개수를 맞춤)
     * @param {Array<Array<Object>>} data - 2차원 배열 데이터
     * @param {number} rowIndex - 계산하려는 행의 인덱스
     * @returns {number} - 해당 행의 셀 개수
     */
    rowCount(data, rowIndex) {
      if (rowIndex < 0 || rowIndex >= data.length) return 0; // 유효하지 않은 인덱스 처리

      // 비교 대상 인덱스 계산
      let compareIndex = rowIndex % 2 === 0 ? rowIndex + 1 : rowIndex - 1;
      compareIndex = Math.max(0, Math.min(data.length - 1, compareIndex));

      // 현재 배열과 비교 배열 가져오기
      const currentArray = data[rowIndex].list || [];
      const compareArray = data[compareIndex].list || [];

      // 둘 중 긴 배열의 길이를 반환
      return Math.max(currentArray.length, compareArray.length);
    },

    has(inspectList, key) {
      return inspectList.filter(item => item.label === key).length > 0;
    }

  }
}
</script>

<style scoped lang="scss">
.options {
  display: grid;
  gap-columns: 10px;
  grid-template-columns: 45fr 55fr;

  &.black > li { color: #3C3C3C; h5 { color: #3C3C3C; }; }
  &.blue > li { color:#4839EB; h5 { color:#4839EB; } }
  li {
    padding: 4px 0;
    display: flex;
    align-items: center;
    font-size: 13px;
    font-weight: 400;
  }
  h5 {
    font-weight: 700;
    font-size: 14px;
    margin-left: 4px;
    margin-right: 4px;

    &.first { margin-left: 0; }
  }
}
.gap-1 {
  gap: 2px !important;
}

table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  border-top: 1px solid #cdcdcd;
  border-left: 1px solid #cdcdcd;

  break-inside: avoid;
  th,
  td {
    border-right: 1px solid #cdcdcd;
    border-bottom: 1px solid #cdcdcd;
  }
  th {
    background-color: #ECECEC;
    font-weight: 700;
    text-align: center;
    height: 26px;
  }
  td {
    padding: 2px 7px ;
  }
}

.options {
  li { padding: 2px 0; }
}

</style>
